module.exports = __webpack_public_path__ + "img/product_item_1.656d4dc4.png";